import { useDictionary } from '@/shared/lib/i18n';

export type RjWhatsappMessageParams = {
  candidateFirstName: string;
  recruiterFirstName: string;
  companyName: string;
  jobBoardName: string;
  vacancyName: string;
  vacancyLocation: string;
  vacancySalary: string;
  vacancyShift: string;
  includeEmailNote: boolean;
};

export const useRjWhatsappMessageBuilder = (): ((params: RjWhatsappMessageParams) => string) => {
  const dictionary = useDictionary();
  return (params) => dictionary.rjCommHubWhatsAppMessageString(params);
};
